export default __webpack_public_path__ + "static/media/sf-yogi.f35fe231.jpg";